'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globals = require('../mixins/globals');

var _globals2 = _interopRequireDefault(_globals);

var _UiSelect = require('../material/UiSelect.vue');

var _UiSelect2 = _interopRequireDefault(_UiSelect);

var _UiAlert = require('../material/UiAlert.vue');

var _UiAlert2 = _interopRequireDefault(_UiAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CrearUsuario',
  mixins: [_globals2.default],
  components: {
    UiSelect: _UiSelect2.default,
    UiAlert: _UiAlert2.default
  },
  data: function data() {
    return {
      currentUser: {},
      locals: [{ text: 'Todos', value: 0, r_id: 0 }],
      restaurants: [{ text: 'Todos', value: 0 }],
      selectableLocals: [],
      user: {
        email: '',
        name: '',
        username: '',
        password: '',
        dni: null,
        tempLocal: null,
        tempRestaurant: null
      },
      responseUsers: false,
      disabledCancel: false,
      loadingCreate: false,
      disabledCreate: false,
      flagName: false,
      flagEmail: false,
      flagUsername: false,
      flagPassword: false,
      flagRole: false,
      flagRestaurant: false,
      flagLocal: false,
      flagDni: false,
      flagAdmin: false,
      error: {
        status: false,
        messages: []
      }
    };
  },

  computed: {
    setRestaurant: function setRestaurant() {
      for (var i in this.restaurants) {
        if (this.restaurants[i].value == this.currentUser.restaurante_id) {
          this.user.tempRestaurant = this.restaurants[i];
          this.flagRestaurant = true;
          this.buildSelectableLocals(this.restaurants[i]);
          return this.user.tempRestaurant.text;
        }
      }
    }
  },
  watch: {
    'user.name': function userName(val, oldval) {
      if (val.length > 2) {
        this.flagName = true;
        if (this.flagEmail && this.flagUsername && this.flagPassword && this.flagRestaurant && this.flagLocal && this.flagDni) {
          this.disabledCreate = true;
        } else {
          this.disabledCreate = false;
        }
      } else {
        this.flagName = false;
        this.disabledCreate = false;
      }
    },
    'user.email': function userEmail(val, oldval) {
      if (this.validateEmail(val)) {
        this.flagEmail = true;
        if (this.flagName && this.flagUsername && this.flagPassword && this.flagRestaurant && this.flagLocal && this.flagDni) {
          this.disabledCreate = true;
        } else {
          this.disabledCreate = false;
        }
      } else {
        this.flagEmail = false;
        this.disabledCreate = false;
      }
    },
    'user.username': function userUsername(val, oldval) {
      if (val.length > 5) {
        this.flagUsername = true;
        if (this.flagName && this.flagEmail && this.flagPassword && this.flagRestaurant && this.flagLocal && this.flagDni) {
          this.disabledCreate = true;
        } else {
          this.disabledCreate = false;
        }
      } else {
        this.flagUsername = false;
        this.disabledCreate = false;
      }
    },
    'user.password': function userPassword(val, oldval) {
      if (val.length > 5) {
        this.flagPassword = true;
        if (this.flagName && this.flagEmail && this.flagUsername && this.flagRestaurant && this.flagLocal && this.flagDni) {
          this.disabledCreate = true;
        } else {
          this.disabledCreate = false;
        }
      } else {
        this.flagPassword = false;
        this.disabledCreate = false;
      }
    },
    'user.tempLocal': function userTempLocal(val, oldval) {
      if (val !== null && typeof val !== 'undefined') {
        this.flagLocal = true;
        if (this.flagName && this.flagEmail && this.flagUsername && this.flagPassword && this.flagRestaurant && this.flagDni) {
          this.disabledCreate = true;
        } else {
          this.disabledCreate = false;
        }
      } else {
        this.flagLocal = false;
        this.disabledCreate = false;
      }
    },
    'user.tempRestaurant': function userTempRestaurant(val, oldval) {
      if (val !== null && typeof val !== 'undefined') {
        this.buildSelectableLocals(val);

        this.flagRestaurant = true;
        if (this.flagName && this.flagEmail && this.flagUsername && this.flagPassword && this.flagLocal && this.flagDni) {
          this.disabledCreate = true;
        } else {
          this.disabledCreate = false;
        }
      } else {
        this.flagRestaurant = false;
        this.disabledCreate = false;
      }
    },
    'user.dni': function userDni(val, oldval) {
      var _len = val.toString().length;
      if (_len >= 8) {
        this.flagDni = true;
        if (this.flagName && this.flagEmail && this.flagUsername && this.flagPassword && this.flagLocal) {
          this.disabledCreate = true;
        } else {
          this.disabledCreate = false;
        }
      } else {
        this.flagDni = false;
        this.disabledCreate = false;
      }
    },
    'error.status': function errorStatus(val, old) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.error.status = false;
        }, 2000);
      }
    }
  },
  created: function created() {
    this.fetchUser();
    this.fetchRestaurant();
    this.fetchLocal();
    this.flagAdmin = this.isCurrentUserAdmin();
  },

  methods: {
    isCurrentUserAdmin: function isCurrentUserAdmin() {
      if (window.localStorage.getItem('role') === 'admin') {
        return true;
      } else {
        return false;
      }
    },
    fetchUser: function fetchUser() {
      var _this2 = this;

      var _url = '/admin/users/' + this.uid;

      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        _this2.currentUser = response.data;
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this2.$router.go({
            name: 'sign'
          });
        }
      });
    },
    buildSelectableLocals: function buildSelectableLocals(restaurant) {
      if (this.user.tempLocal != null) {
        if (this.user.tempLocal.r_id != restaurant.value && this.user.tempLocal.r_id != 0) {
          this.user.tempLocal = null;
        }
      }
      this.selectableLocals = [];
      for (var i in this.locals) {
        if (this.locals[i].r_id == restaurant.value || this.locals[i].r_id == 0) {
          this.selectableLocals.push(this.locals[i]);
        }
      }
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    onSubmitCreate: function onSubmitCreate() {
      var _this3 = this;

      this.error.status = false;
      this.error.messages = [];
      var _url = '/admin/users/create';
      this.disabledCancel = true;
      this.loadingCreate = true;
      var _temp = {
        name: this.user.name,
        email: this.user.email,
        dni: +this.user.dni,
        local_id: +this.user.tempLocal.value,
        restaurante_id: +this.user.tempRestaurant.value,
        username: this.user.username,
        password: this.user.password
      };
      this.$http.post(_url, _temp).then(function (response) {
        _this3.disabledCancel = false;
        _this3.loadingCreate = false;
        _this3.$router.go({
          name: 'usuarios-lista'
        });
      }, function (response) {
        _this3.disabledCancel = false;
        _this3.loadingCreate = false;
        _this3.error.status = true;
        for (var prop in response.data) {
          var _msg = response.data[prop];
          _this3.error.messages.push(_msg[0]);
        }
      });
    },
    fetchRestaurant: function fetchRestaurant() {
      var _this4 = this;

      var _url = '/admin/restaurant';

      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _data.forEach(function (val) {
          _this4.restaurants.push({
            text: val.name,
            value: val.id + ''
          });
        });
        // let _data = response.data
        _this4.$nextTick(function () {
          _this4.responseUsers = true;
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this4.person = response.data;
          _this4.$router.go({
            name: 'sign'
          });
        }
      });
    },
    fetchLocal: function fetchLocal() {
      var _this5 = this;

      var _url = '/admin/local';

      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _data.forEach(function (val) {
          _this5.locals.push({
            text: val.name,
            value: val.id + '',
            r_id: val.restaurante_id
          });
        });
        // let _data = response.data
        _this5.$nextTick(function () {
          _this5.responseUsers = true;
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this5.person = response.data;
          _this5.$router.go({
            name: 'sign'
          });
        }
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"bgTransition\">\n  <template v-if=\"!responseUsers\">\n    <div class=\"preload-app\">\n      <ui-progress-linear :show=\"!responseUsers\" color=\"black\"></ui-progress-linear>\n    </div>\n  </template>\n  <template v-else=\"\">\n    <div class=\"header-section h_person\">\n      <h2 v-if=\"titleShow\" transition=\"slideLeft\">Crear Usuario</h2>\n    </div>\n    <section class=\"section-person\">\n      <div class=\"width-person bg-white\" style=\"padding: 15px;\">\n        <ui-alert :dismissible=\"false\" v-if=\"error.status\" type=\"error\">\n          <span style=\"display:block;\" v-for=\"item of error.messages\">{{ item }}</span>\n        </ui-alert>\n        <ui-textbox type=\"text\" name=\"name\" label=\"Nombre y Apellido(*)\" :value.sync=\"user.name\" autocomplete=\"off\"></ui-textbox>\n\n        <ui-textbox type=\"email\" name=\"email\" label=\"Correo(*)\" :value.sync=\"user.email\" autocomplete=\"off\"></ui-textbox>\n\n        <ui-textbox type=\"number\" name=\"document_value\" label=\"DNI(*)\" :value.sync=\"user.dni\" autocomplete=\"off\" validation-rules=\"numeric\"></ui-textbox>\n\n        <ui-select v-if=\"flagAdmin\" name=\"level\" label=\"Restaurante(*)\" :options=\"restaurants\" placeholder=\"Seleccione una opción\" :value.sync=\"user.tempRestaurant\"></ui-select>\n\n        <ui-textbox v-if=\"!flagAdmin\" type=\"text\" name=\"restaurant\" label=\"Restaurante(*)\" :value.sync=\"setRestaurant\" disabled=\"\"></ui-textbox>\n\n        <ui-select name=\"level\" label=\"Local(*)\" :options=\"selectableLocals\" placeholder=\"Seleccione una opción\" :value.sync=\"user.tempLocal\" :disabled=\"!flagRestaurant\"></ui-select>\n\n        <ui-textbox type=\"text\" name=\"username\" label=\"Usuario(*) 6 caracteres min\" placeholder=\"Usuario\" :value.sync=\"user.username\" autocomplete=\"off\"></ui-textbox>\n\n        <ui-textbox type=\"password\" name=\"password\" label=\"Contraseña(*) 6 caracteres min\" :value.sync=\"user.password\" autocomplete=\"off\"></ui-textbox>\n        <p style=\"font-size:12px; color: rgba(0, 0, 0, 0.54);\">(*) Campos requeridos</p>\n\n        <div class=\"text-center\" style=\"color: #fff;\">\n          <ui-button @click=\"backToUrl('usuarios-lista')\" text=\"Cancelar\" color=\"lanacional-primario\" :disabled=\"disabledCancel\" raised=\"\"></ui-button>\n\n          <ui-button @click=\"onSubmitCreate()\" text=\"Guardar\" color=\"lanacional-cuarto\" :loading=\"loadingCreate\" :disabled=\"!disabledCreate\"></ui-button>\n        </div>\n      </div>\n    </section>\n  </template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-3387e6a3", module.exports)
  } else {
    hotAPI.update("_v-3387e6a3", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}